'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doLoadCmsModules = doLoadCmsModules;

var _effects = require('redux-saga/effects');

var _cmsDataToModuleArray = require('components/CmsPage/cmsDataToModuleArray');

var _modules = require('components/CmsPage/modules');

var defaultModuleMap = _interopRequireWildcard(_modules);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadCmsModules);

function doLoadCmsModules(client, cmsData) {
  var moduleMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModuleMap;
  var loaders;
  return _regenerator2.default.wrap(function doLoadCmsModules$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          loaders = (cmsData.modules || []).map(function (moduleDef) {
            return [(0, _cmsDataToModuleArray.findModule)(moduleMap, moduleDef), moduleDef];
          }).filter(function (_ref) {
            var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
                module = _ref2[0];

            return module && module.loadSaga;
          }).map(function (_ref3) {
            var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                module = _ref4[0],
                moduleDef = _ref4[1];

            return (0, _effects.call)(module.loadSaga, client, moduleDef);
          });
          _context.next = 3;
          return (0, _effects.all)(loaders);

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}